// var nb = require('./nb');
// var View = require('./view/Toast');
// var Model = require('./model/Toast');
// var view = new View();
// var model = new Model();
//
// view.setModel(model);
//
// nb.model.onChange(nb.opts.clientReady, function () {
//     setTimeout(function(){
//         view.$().appendTo(document.body);
//     },200);
//
// }, this);
//
// module.exports = model;
var nb = require('./nb');
var flag;
var Model = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
        },
        setOpts: function (inOpts) {
            var self = this;
            var opts = inOpts || {};
            var timeOut = opts.timeOut || 3;
            var text = inOpts.text;
            var status = inOpts.status || 'info';
            var pos = inOpts.pos || 'top-center';
            flag = UIkit || false;
            if (flag) {
                UIkit.notify({
                    message: text,
                    status: status,
                    timeout: timeOut * 1000,
                    pos: pos
                });
            }
            // flag = false;
        }


    }
});
var model = new Model();
module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/toast.js
// module id = 5
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40